<template>
  <non-property-layout>
    <Loading v-if="isLoading" />
    <div class="flex flex-col justify-center min-h-600">
      <!-- component -->
      <div
        class="m-auto my-10 border-2 border-gray-300 shadow-md rounded-md w-12/12 lg:w-6/12 md:w-8/12 sm:10/12"
      >
        <div class="px-8 py-8 rounded-xl">
          <h1 name="login-title" class="mb-4 text-center font-bold text-2xl">
            Your email ({{ user?.loginEmail }}) has not been verified. Please check your email for a
            confirmation link to begin using SafetyNet.
          </h1>

          <p>If you have not received an email, please click below to send again.</p>
          <BaseButton :onclick="requestEmailConfirmation" class="mt-3">
            Resend Confirmation Email
          </BaseButton>

          <ErrorDisplay
            :label="confirmationErrorLabel"
            :message="confirmationError"
            :isVisible="confirmationError != null"
          />
        </div>
      </div>
    </div>
  </non-property-layout>
</template>
<script setup lang="ts">
import { useUserStore } from "../store/userStore";
import { useBldgStore } from "../store/bldgStore";
import { useRouter } from "vue-router";

const userStore = useUserStore();
const bldgStore = useBldgStore();
const router = useRouter();

let isLoading = ref(false);
var property = computed(() => bldgStore.property);
var user = computed(() => userStore.user);

onMounted(loadData);
onActivated(() => loadData);

var returnUrl = ref<string | undefined>(undefined);

async function loadData() {
  returnUrl.value =
    router.currentRoute.value?.query["returnUrl"]?.toString() ||
    router.currentRoute.value?.hash?.substring(1);

  if (returnUrl.value) console.log("return Url found: " + returnUrl.value);

  // force get user in case user already confirmed in another tab
  await tryRedirectUserBack();
}

let confirmationErrorLabel = ref<string | undefined>(undefined);
let confirmationError = ref<string | undefined>(undefined);
let confirmationRequestSuccess = ref(false);

async function requestEmailConfirmation() {
  console.log("Check if user already confirmed before sending another email");
  await tryRedirectUserBack();

  console.log(`Requesting email confirmation for ${user.value?.loginEmail}`);
  confirmationRequestSuccess.value = false;
  confirmationError.value = undefined;
  confirmationErrorLabel.value = undefined;
  isLoading.value = true;

  let resultError = await userStore.requestEmailVerification(
    user.value?.loginEmail!,
    property.value?.siteCode!
  );

  if (resultError && resultError.length > 0) {
    confirmationErrorLabel.value =
      "Couldn't send Verification email. Is the email you entered correct?";
    confirmationError.value = resultError;
    confirmationRequestSuccess.value = false;
  } else {
    confirmationRequestSuccess.value = true;
  }

  isLoading.value = false;
}

async function tryRedirectUserBack() {
  await userStore.getUser(property.value?.siteCode!, user.value?.portalId!, true);

  if (userStore.isEmailVerifiedOrNotRequired) {
    if (returnUrl.value) {
      router.replace(returnUrl.value);
    } else {
      router.replace("/" + property.value?.siteCode);
    }
  }
}
</script>
